import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=b88c40b8&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=ts"
export * from "./UserIcon.vue?vue&type=script&lang=ts"
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=b88c40b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c40b8",
  null
  
)

export default component.exports